import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import './style.sass';

const teamCustomer = {
    crewList: [
        {
            crewItemImg: '',
            crewItemTitle: 'Никита Филиппов',
            crewItemSubtitle: 'Руководитель дирекции интернет продаж',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Павел Куданкин',
            crewItemSubtitle: 'Руководитель направления веб-проектов',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Артем Гусаров',
            crewItemSubtitle: 'Эксперт в направлении веб-проектов',
        },
        {
            crewItemImg: '',
            crewItemTitle: 'Денис Корнеев',
            crewItemSubtitle: 'Веб-аналитик в центре аналитики веб-продаж',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <div className="pochtabank-teamCustomer">
                <FullWrapper>
                    <div className="pochtabank-teamCustomer__Title">Команда заказчика </div>
                    <CrewContainer container={teamCustomer} />
                </FullWrapper>
            </div>
        );
    }
}

export default Team;
